(function() { window.GUID_3b3bc36d_54dc_457f_8342_e1560586d317 = { getGuid: function() { return "3b3bc36d-54dc-457f-8342-e1560586d317"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-games-v2",
                        callback: (accordion, e) => {
                            //=================================================================================//
                            //============================// Variation T-CSR
                            var _a;
                            const $absoluteMaximumTCSRVariation = $(`#absolute-maximum-tcsr-variation-${accordion.ContentId}`);
                            if ($absoluteMaximumTCSRVariation.length) {
                                const absoluteMaximumTCSRVariation = $absoluteMaximumTCSRVariation.val();
                                let absoluteMaximumTCSRVariationValue = parseFloat(((_a = absoluteMaximumTCSRVariation === null || absoluteMaximumTCSRVariation === void 0 ? void 0 : absoluteMaximumTCSRVariation.toString()) !== null && _a !== void 0 ? _a : "").replace(",", "."));
                                const isValid = !(absoluteMaximumTCSRVariationValue == null ||
                                    CS.Helper.isNullOrWhiteSpace(absoluteMaximumTCSRVariation) ||
                                    isNaN(absoluteMaximumTCSRVariationValue));
                                if (isValid) {
                                    const $games = accordion.$Container.find(".cs-games-v2__game");
                                    if ($games.length) {
                                        $games.each((index, game) => {
                                            var _a;
                                            try {
                                                const $game = $(game);
                                                const tcsr = $game.find("[data-tcsr]").attr("data-tcsr");
                                                const tcsrValue = parseFloat(((_a = tcsr === null || tcsr === void 0 ? void 0 : tcsr.toString()) !== null && _a !== void 0 ? _a : "").replace(",", ".")) || 0;
                                                const variationPercentage = (Math.abs(tcsrValue) / absoluteMaximumTCSRVariationValue) *
                                                    100;
                                                let variationCssClass = "variation";
                                                if (tcsrValue > 0) {
                                                    variationCssClass += " positive";
                                                }
                                                else if (tcsrValue < 0) {
                                                    variationCssClass += " negative";
                                                }
                                                else {
                                                    variationCssClass += " neutral";
                                                }
                                                let style = `width: ${variationPercentage}%;`;
                                                if (variationCssClass === "variation neutral") {
                                                    style = `width: 8px`;
                                                }
                                                const result = ` 
                  <div class="variation-bar">
                    <div class="${variationCssClass}" style="${style}"></div>
                  </div>
                `;
                                                $game.append(result);
                                            }
                                            catch (error) {
                                                console.error(error);
                                            }
                                        });
                                    }
                                }
                            }
                            accordion.$Content.offon("click.tcsrVariationDivisionItemClicked", ".tcsr-variation-container", (e) => {
                                try {
                                    const $tcsrVariationContainer = $(e.currentTarget);
                                    const divisionId = $tcsrVariationContainer.attr("data-division-id");
                                    if (CS.Helper.isNullOrWhiteSpace(divisionId)) {
                                        return;
                                    }
                                    // const $matchesOfDivision = accordion.$Content.find(
                                    //   `.cs-games-v2__match[data-division-id="${divisionId}"]`
                                    // );
                                    const $allMatches = accordion.$Content.find(".cs-games-v2__match");
                                    if (!$allMatches.length) {
                                        return;
                                    }
                                    $tcsrVariationContainer.toggleClass("selected");
                                    const divisionIsSelected = $tcsrVariationContainer.hasClass("selected");
                                    if (divisionIsSelected) {
                                        $tcsrVariationContainer
                                            .siblings(".tcsr-variation-container")
                                            .removeClass("selected");
                                    }
                                    $allMatches.each((index, match) => {
                                        const $match = $(match);
                                        const isDivisionMatch = $match.attr("data-division-id") == divisionId;
                                        if (divisionIsSelected) {
                                            if (isDivisionMatch) {
                                                $match.removeClass("hidden");
                                            }
                                            else {
                                                $match.addClass("hidden");
                                            }
                                        }
                                        else {
                                            $match.removeClass("hidden");
                                        }
                                    });
                                    const $items = accordion.$Content.find(".items .item");
                                    $items.each((index, item) => {
                                        const $item = $(item);
                                        const $matches = $item.find(".cs-games-v2__match");
                                        const $hiddenMatches = $matches.filter(".hidden");
                                        if ($matches.length === $hiddenMatches.length) {
                                            $item.addClass("hidden");
                                        }
                                        else {
                                            $item.removeClass("hidden");
                                        }
                                    });
                                }
                                catch (error) {
                                    console.error("Error while handling tcsr variation division item clicked", error);
                                }
                            });
                            //=================================================================================//
                            //============================// Games popup
                            accordion.$Content.offon("click.gamesClicked", ".items .item .match .game", (e) => {
                                if (!e || !e.currentTarget) {
                                    return;
                                }
                                e.preventDefault();
                                const $game = $(e.currentTarget);
                                const popupUrl = $game.data("popup-url");
                                if (popupUrl && !CS.Helper.isNullOrWhiteSpace(popupUrl)) {
                                    CS.Controls.Popup.ShowAjaxModal(popupUrl, {}, ({ popup }) => {
                                        // On load
                                    }, ({ popup }) => {
                                        // On close
                                    }, true, true);
                                }
                            });
                            CS.Controls.FiltersBar.Events.ChipClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-games-${accordion.ContentId}-bar`,
                                callback: (filtersBar, e) => {
                                    if (filtersBar.uiFreezed)
                                        return;
                                    filtersUIFreezed = true;
                                    const url = WallSections.GamesSection.formatSectionUrl(e.data.toggleUrl, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersBar.uiFreezed = false;
                                        filtersUIFreezed = false;
                                        WallSections.GamesSection.updateUI(accordion);
                                        yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                },
                            });
                            CS.Controls.FiltersBar.Events.SortItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-games-${accordion.ContentId}-bar`,
                                callback: (filtersBar, e) => {
                                    const url = WallSections.GamesSection.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.GamesSection.updateUI(accordion);
                                        yield filtersBar.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                },
                            });
                            //=================================================================================//
                            //============================// Pin results to top
                            accordion.$Content.offon("click.pinResults", "#button-pin-results", (e) => {
                                const $btn = $(e.currentTarget);
                                const { pinUrl, successmsg } = $btn.data("html");
                                if (pinUrl != null) {
                                    accordion.pinSection(pinUrl, accordion, () => {
                                        if (!CS.Helper.isNullOrWhiteSpace(successmsg)) {
                                            CS.Controls.Snackbar.Show({
                                                Id: "pin-toggle-success",
                                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                Animation: CS.Enumeration.SnackbarAnimation.Slide,
                                                Type: CS.Enumeration.SnackbarType.Success,
                                                Message: successmsg,
                                                AutoHideDuration: 3000,
                                            });
                                        }
                                    });
                                }
                            });
                            //if (!GamesSection.isWallLayout) {
                            //    GamesSection.removeLazyloadingTrigger(accordion);
                            //    return;
                            //}
                            let filtersUIFreezed = false;
                            //=================================================================================//
                            //============================// Filters V2
                            CS.Controls.Filters.Events.SortItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-games-games-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = WallSections.GamesSection.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.GamesSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-games-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.Controls.Filters.Events.FiltersToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-games-${accordion.ContentId}-bar`,
                                callback: (filters, e) => __awaiter(this, void 0, void 0, function* () {
                                    if (e.data.filtersStateSerialized)
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-games-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                }),
                            });
                            CS.Controls.Filters.Events.ItemClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-games-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = WallSections.GamesSection.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.GamesSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-games-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.Controls.Filters.Events.FilterToggleClicked({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-games-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = WallSections.GamesSection.formatSectionUrl(e.data.toggleUrl, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.GamesSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-games-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                            CS.Controls.Filters.Events.TextChanged({
                                selector: CS.DOM.$body,
                                childSelector: `#filters-drawer-games-${accordion.ContentId}-bar`,
                                callback: (filters, e) => {
                                    const url = WallSections.GamesSection.formatSectionUrl(e.data.url, accordion);
                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                        filtersUIFreezed = false;
                                        WallSections.GamesSection.updateUI(accordion);
                                        yield filters.UpdateFiltersStateInBrowserUrl(e.data.filtersStateSerialized);
                                    }), url);
                                    const $parentPopup = $(`#popup-filters-drawer-filters-games-${accordion.ContentId}-bar`);
                                    const parentPopup = CS.Controls.GetInstance(CS.Controls.Popup, $parentPopup, true);
                                    if (parentPopup != null)
                                        parentPopup.Close();
                                },
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=games-section.ready.js.map
